import { getToken } from '../../utils/tokens'
import { isEmpty, validateJWT, global } from '@navinc/utils'

const { CLIENT_REACHARD_RSA_PUBLIC_KEY_PEM } = global?.process?.env ?? ''

export const getIsSessionExpired = () => {
  const token = getToken()
  const validatedToken = validateJWT(token, CLIENT_REACHARD_RSA_PUBLIC_KEY_PEM, { ignoreExpiration: false })

  return isEmpty(validatedToken)
}
